import { $$ } from '../dom';

const TRIGGER_CLASS = '.js-scroll-block';
const SCROLL_BLOCK_CLASS = 'scroll-block';

class ScrollBlock {
    public constructor(trigger: HTMLElement) {
        trigger.addEventListener('click', (event): void => {
       /*     event.preventDefault();
            event.stopPropagation();*/
            if (document.body.classList.contains(SCROLL_BLOCK_CLASS)) {
                document.body.classList.remove(SCROLL_BLOCK_CLASS);
            } else {
                document.body.classList.add(SCROLL_BLOCK_CLASS);
            }
        });
    }
}

export function scrollBlock(): void {
    $$(TRIGGER_CLASS).map(
        (element: HTMLElement): ScrollBlock => {
            return new ScrollBlock(element);
        },
    );
}
